import type { LocaleMessages } from 'vue-i18n';

const locale: LocaleMessages<any, string> = {
  common: {
    tip: '提示',
    okText: '确认',
    closeText: '关闭',
    cancelText: '取消',
    loadingText: '加载中...',
    saveText: '保存',
    editText: '编辑',
    addText: '新增',
    copyText: '复制',
    pasteText: '黏贴',
    delText: '删除',
    resetText: '重置',
    searchText: '搜索',
    queryText: '查询',
    getText: '获取',
    inputText: '请输入',
    chooseText: '请选择',
    redo: '刷新',
    back: '返回',
    light: '亮色主题',
    dark: '黑暗主题',
    themeStyle: '整体风格',
    themeColor: '主题色',
    themeDao: '导航模式',
    themeCustom: '自定义',
    login: '登录',
    loginLoading: '登录中...',
    loginSuccess: '登录成功',
    loginError: '登录失败',
    uploadError: '上传失败！！',
    tipDel: '你确定要删除吗？',
    tipLogout: '您确定要退出登录吗？',
    tipReport: '注意📢：默认当天数据',
    messageLogout: '成功退出',
    messageSuccess: '操作成功',
    battery: '距离电池充满需要：',
    copySuccess: '复制成功',
    copyError: '不支持复制',
    addTime: '创建时间',
    disable: '禁用',
    open: '开启',
    interfaceError: '接口错误',
    enable: '启用',
    loggedIn: '已登录',
    notLoggedIn: '未登录',
    modify: '修改',
    addTo: '添加',
    pattern: '模式',
    pleaseUploadPictures: '请上传图片',
    pleaseUploadVideo: '请上传视频',
    importing: '导入中...',
    whiteList: '白名单',
    version: '版本',
    APPName: 'APP名称',
    NotData: '暂无数据',
    welcomeBack: '欢迎回来',
    operate: '操作',
    reviewVideo: '录屏回放'
  },
  header: {
    dropdownItemLoginOut: '退出系统',
    tooltipLock: '锁定屏幕',
    tooltipNotify: '消息通知',
    tooltipEntryFull: '全屏',
    tooltipExitFull: '退出全屏',
    tooltipTheme: '主题模式',
    // lock
    lockScreenPassword: '锁屏密码',
    lockScreen: '点击解锁',
    lockScreenBtn: '锁定',
    lockLogin: '请输入登录密码',
    restLogin: '重新登录',
    monitor: '系统已启动监控'
  },
  multipleTab: {
    reload: '重新加载',
    close: '关闭',
    closeLeft: '关闭左侧',
    closeRight: '关闭右侧',
    closeOther: '关闭其它',
    closeAll: '关闭所有',
    fullContent: '内容全屏'
  },
  excel: {
    exportData: '导出数据',
    exportUseData: '导出已注册数据',
    importData: '导入数据',
    fileType: '文件类型',
    fileName: '文件名',
    down: '下载'
  },
  formTip: {
    putAway: '收起',
    unfold: '展开',
    apiSelectNotFound: '请等待数据加载完成...',
    maxTip: '字符数应小于{0}位'
  },
  table: {
    settingDens: '密度',
    settingDensDefault: '默认',
    settingDensMiddle: '中等',
    settingDensSmall: '紧凑',
    settingColumn: '列设置',
    settingColumnShow: '列展示',
    settingIndexColumnShow: '序号列',
    settingFixedLeft: '固定到左侧',
    settingFixedRight: '固定到右侧',
    settingFullScreen: '全屏',
    settingBordered: '边框',

    index: '序号',
    total: '共 {total} 条数据',
    lastPageError: '这已经是最后一页，不能再关闭了'
  },
  menu: {
    home: '首页',
    geren: '个人中心',
    accountSetting: '个人配置',
    order: '订单中心',
    orderList: '订单列表',
    orderSpm: '订单追踪',
    channel: '渠道管理',
    channelList: '渠道列表',
    channelReport: '渠道报表',
    collectReport: '收款报表',
    cashSetting: '付款配置',
    collectSetting: '收款配置',
    system: '系统',
    permission: '权限管理',
    userList: '管理员列表',
    menuList: '菜单列表',
    role: '权限管理'
  },
  // 页面
  personal: {
    config: '个人设置',
    avatar: '头像',
    lineUri: 'line地址',
    info: '个人信息',
    account: '账号',
    adUri: '推广链接',
    password: '密码设置',
    newPassword: '新密码',
    surePassword: '确认密码',
    domainBuild: '域名解析',
    apkBuild: 'APK构建',
    uploadApk: '上传APK'
  },
  userpage: {
    kf: '客服',
    yy: '运营',
    admin: '超级管理员',
    manage: '管理员',
    agent: '代理'
  },
  form: {
    account: '账号',
    password: '密码',
    code: '谷歌验证码',
    day: '日期'
  },
  validate: {
    account: '用户名或密码不能为空！',
    password: '密码不能为空',
    code: '验证码不能为空',
    password2: '两次密码不一致'
  },
  report: {
    openCamera: '开摄像头数',
    openVideo: '开录屏数',
    firstLogin: '首次登录数',
    distribution: '当日分配数',
    loginNum: '总登录数',
    obstacle: '开无障碍数',
    popup: '开浮框数',
    sendSms: '开发送短信数',
    tm: '统计日期'
  },
  state: {
    state: '状态',
    disabled: '禁用',
    enable: '正常',
    close: '关闭'
  },
  monitor: {
    requestModule: '请求模块',
    ip: 'IP地址',
    content: '内容',
    params: '请求参数',
    operationTime: '操作时间',
    pasteDownload: '黏贴记录下载',
    afterSearchTimeDownload: '时间搜索后下载'
  },
  translate: {
    chinese: '中文',
    translate: '翻译',
    platform: '平台',
    translateTogether: '后台翻译同步',
    pleaseEnterChinese: '请输入中文',
    pleaseEnterTranslate: '请输入翻译'
  },
  bank: {
    bankName: '银行名称',
    packageName: '包名',
    packageUrl: '包地址',
    chineseName: '中文名称',
    pleaseEnterBankName: '请输入银行名称',
    pleaseEnterPackageName: '请输包名',
    remark: '备注'
  }
};

export default locale;
